import { Controller } from '@hotwired/stimulus';
import analytics from '../../modules/analytics';

export default class extends Controller {
  // eslint-disable-next-line class-methods-use-this
  trackEvent (e) {
    JSON.parse(e.currentTarget.dataset.analytics).forEach((analyticsEvent) => {
      const { event, properties, options } = analyticsEvent;

      analytics.track(event, properties, options);
    });
  }
}
